import React, { Component } from 'react';
import { formatMoney } from './NeedsAnalysisHelpers';
import Tooltip from '../../../../CommonComponents/Tooltip';
import NotesPopup from '../../NotesPopup/NotesPopupContainer';

export default class NeedsAnalysisView extends Component {
  render() {
    const {
      isPrint,
      isAdviserArea,
      breakdown,
      note,
      hasNoGap,
      onNotesClick,
      clientId,
      goalId,
      subgoalId,
      isCurrentPlan,
    } = this.props;

    return (
      <div className="NewFinancialPlan_Insurance_Breakdown">
        <NotesPopup {...this.props} />
        <section>
          <ul>
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Coverage Gap</span>
                {hasNoGap ? (
                  <span className="pill">No Gap</span>
                ) : (
                  <span className="pill red">
                    {formatMoney(breakdown.NeedsAnalysisCoverageGap)}
                  </span>
                )}
              </span>
            </li>
            {breakdown.NeedsAnalysisAssetsRunOut && (
              <li className="breakdown-item">
                <span className="breakdown-text">
                  <span>Assets Run Out</span>
                  {!isPrint && (
                    <Tooltip
                      tag="i"
                      className="fa fa-question-circle more-info"
                      tooltipchildren={ADV.tooltip_callouts.Insurance.AssetsRunOut.html}
                      orientation={ADV.tooltip_callouts.Insurance.AssetsRunOut.orientation}
                    />
                  )}
                  <span className="pill">{breakdown.NeedsAnalysisAssetsRunOut}</span>
                </span>
              </li>
            )}
            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Current Coverage</span>
                {!isPrint && (
                  <Tooltip
                    tag="i"
                    className="fa fa-question-circle more-info"
                    tooltipchildren={ADV.tooltip_callouts.Insurance.CurrentCoverage.html}
                    orientation={ADV.tooltip_callouts.Insurance.CurrentCoverage.orientation}
                  />
                )}
                <span className="pill">{formatMoney(breakdown.NeedsAnalysisCurrentCoverage)}</span>
              </span>
            </li>

            <li className="breakdown-item">
              <span className="breakdown-text">
                <span>Recommended Coverage</span>
                <span className="pill">
                  {formatMoney(breakdown.NeedsAnalysisRecommendedCoverage)}
                </span>
              </span>
            </li>
            {breakdown.NeedsAnalysis.filter(item => item.Value).map(item => (
              <li key={item.key} className="tab-1">
                <span>{item.Key}</span>
                <span>{formatMoney(item.Value)}</span>
              </li>
            ))}
          </ul>
          <div className="notes">
            <header>
              <span className="recommendations">Recommendation</span>
              {isAdviserArea && !isCurrentPlan && (
                <strong>
                  <a onClick={onNotesClick(clientId, goalId, subgoalId, note.Description)}>
                    <i className="far fa-edit" /> Edit
                  </a>
                </strong>
              )}
            </header>
            <p className="adv-scrollbars">{note.Description}</p>
          </div>
        </section>
      </div>
    );
  }
}
